<div class="w-full h-full">
    <div class="w-700-px mx-auto mt-8">
        <form [formGroup]="updateForm">
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 space-y-6">
                    <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="">
                        <span class="text-xs w-60-px font-semibold">
                            URL:
                        </span>
                        <div class="w-full">
                            <input 
                                class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                                type="text" 
                                placeholder="URL (e.g., https://example.com)" 
                                formControlName="webViewUrl"
                                [class.border-red-500]="updateForm.get('webViewUrl').invalid && updateForm.get('webViewUrl').touched"
                            >
                            <!-- Validation message -->
                            <div *ngIf="updateForm.get('webViewUrl').invalid && updateForm.get('webViewUrl').touched" 
                                 class="text-red-500 text-xs mt-1 ml-1">
                                <span *ngIf="updateForm.get('webViewUrl').hasError('required')">
                                    URL is required
                                </span>
                                <span *ngIf="updateForm.get('webViewUrl').hasError('invalidUrl')">
                                    Please enter a valid URL (must start with http:// or https:// ex. "https://example.com or www.example.com")
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-input flex items-start text-xs py-2 w-full" [appHighlightOnActive]="">
                        <span class="text-xs w-110-px font-semibold">
                            Description:
                        </span>
                        <div class="w-full">
                            <textarea 
                                formControlName="description" 
                                class="placeholder-black focus:outline-none w-full h-70-px bg-gray-100 rounded-md pl-3 resize-none italic" 
                                placeholder="Description" 
                                name="" 
                                id="" 
                                cols="30" 
                                rows="10"
                                [class.border-red-500]="updateForm.get('description').invalid && updateForm.get('description').touched"
                            ></textarea>
                            <!-- Validation message -->
                            <div *ngIf="updateForm.get('description').invalid && updateForm.get('description').touched" 
                                 class="text-red-500 text-xs mt-1 ml-1">
                                Description is required
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col items-start text-xs pl-5 mb-3">
                        <div class="flex items-center space-x-3 font-semibold">
                            <span>Cover Image: </span>
                            <input 
                                type='file' 
                                class="hidden" 
                                (change)="onSelectFile($event)" 
                                #coverImg
                                accept="image/*"
                            >
                            <button 
                                type="button"
                                class="browse-btn px-4 py-2 focus:outline-none" 
                                (click)="coverImg.click()"
                            >
                                Browse...
                            </button>
                            <!-- Show filename if new image selected -->
                            <span *ngIf="imageFile" class="text-xs italic text-gray-600">
                                {{ imageFile.name }}
                            </span>
                        </div>
                        <img 
                            [src]="img" 
                            class="w-full h-200-px object-contain mt-3" 
                            *ngIf="img"
                            alt="Announcement cover image"
                        > 
                        <br/>
                    </div>
                </div>
                <div class="col-span-6">
                    <div class="card-input flex items-center text-xs py-2 w-full mb-3" [appHighlightOnActive]="">
                        <app-date-input
                            class="w-full"
                            label="Date From:"
                            [parentForm]="updateForm"
                            controlName="dateFrom">
                        </app-date-input>
                    </div>
                </div>
                <div class="col-span-6">
                    <div class="card-input flex items-center text-xs py-2 w-full mb-3" [appHighlightOnActive]="">
                        <app-date-input
                            class="w-full"
                            label="Date To:"
                            [parentForm]="updateForm"
                            controlName="dateTo"
                            [min]="minDateTo || updateForm.get('dateTo').value">
                        </app-date-input>
                    </div>
                </div>
            </div>
        </form> 
        <div class="w-full flex items-center justify-center mt-6 mb-4">
            <!-- UPDATED BUTTON WITH DISABLED STATE -->
            <button 
                (click)="update()"
                [disabled]="isSubmitDisabled()"
                [ngClass]="{'opacity-50 cursor-not-allowed': isSubmitDisabled()}"
                class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2 mb-5"
                [title]="updateForm.invalid ? 'Please fix validation errors' : (isSubmitDisabled() ? 'No changes to save' : 'Save changes')"
            >
                Update
            </button>
        </div>
    </div>
</div>